var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAllTimeSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-activity_history",
    d: "M10.882,6A4.908,4.908,0,0,0,6,10.889V31.146c-.235,3.248,1.323,6.719,4.7,6.844a1.332,1.332,0,0,0,.184.01H33.089a4.511,4.511,0,0,0,3.589-1.981,7.588,7.588,0,0,0,0-8.483,4.511,4.511,0,0,0-3.589-1.981h-.444V10.889A4.908,4.908,0,0,0,27.759,6Zm0,2.667H27.759a2.2,2.2,0,0,1,2.221,2.222V25.555h-19.1a1.332,1.332,0,0,0-.175.01,4.342,4.342,0,0,0-2.045.566V10.889A2.2,2.2,0,0,1,10.882,8.667Zm2.665,2.667a1.333,1.333,0,0,0,0,2.667h1.776a1.333,1.333,0,0,0,0-2.667Zm6.218,0a1.333,1.333,0,0,0,0,2.667h5.329a1.333,1.333,0,0,0,0-2.667Zm-6.218,4.444a1.333,1.333,0,0,0,0,2.667h5.329a1.333,1.333,0,0,0,0-2.667Zm9.771,0a1.333,1.333,0,0,0,0,2.667h1.776a1.333,1.333,0,0,0,0-2.667Zm-9.771,4.444a1.333,1.333,0,0,0,0,2.667h5.329a1.333,1.333,0,0,0,0-2.667Zm-2.665,8c2.905,0,2.905,7.111,0,7.111S7.977,28.222,10.882,28.222Zm4.122,0H33.089a1.8,1.8,0,0,1,1.435.882,4.941,4.941,0,0,1,0,5.347,1.8,1.8,0,0,1-1.435.882H15A8.3,8.3,0,0,0,15,28.222Z",
    transform: "translate(-5.974 -6)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllTimeSheet);
export default __webpack_public_path__ + "static/media/iconAllTimeSheet.79653d81edb01b60c6f93e196081fb8b.svg";
export { ForwardRef as ReactComponent };